module.exports = __webpack_public_path__ + "static/media/circle-info-light.66cd0ba0.svg";